module.exports = __webpack_public_path__ + "img/cloud-plus-fill.3c4d3a25.svg";